module.exports = __webpack_public_path__ + "static/uet-728551671f779fa1c85a199be026d2a7.jpg";